/*
 * @作者: kerwin
 * @公众号: 大前端私房菜
 */
import axios from "axios";

axios.defaults.baseURL = 'http://localhost/';
// axios.defaults.baseURL = 'https://lcapi.cn';

// 定义需要添加token的目标baseURL
// const TARGET_BASE_URL = 'https://api.lcapi.cn:3000/';
// const REQURL = 'http://localhost:3000';


// Add a request interceptor
axios.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    // console.log("添加请求数据", config)
    // if (config.url.includes(TARGET_BASE_URL)) {
    //   console.log("带token请求")

    //   const token = localStorage.getItem("token");
    //   if (token) {
    //     config.headers.Authorization = `Bearer ${token}`;
    //   } else {
    //     console.log("无token")

    //     // 若没有token，删除可能存在的空Authorization头
    //     delete config.headers.Authorization;
    //   }
    // } else {
    //   // 非目标地址，确保不携带Authorization头
    //   delete config.headers.Authorization;
    // }

    const token = localStorage.getItem("token");
    config.headers.Authorization = `Bearer ${token}`;

    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
axios.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data

    // console.log("拦截器响应", response.headers)
    const { authorization } = response.headers;
    authorization && localStorage.setItem("token", authorization);

    return response;
  },
  function (error) {
    //任何超出2xx范围的状态代码都会触发此功能
    //处理响应错误
    const { status } = error.response;
    if (status === 401) {
      localStorage.removeItem("token");
      window.location.href = "#/login";
    }
    return Promise.reject(error);
  }
);
